export default __webpack_public_path__ + "static/media/c.6d7e9478.jpg";